import { endpoints, request } from '!core/api';

export const userContactsServices = {
  userContacts: ({ contactType }) =>
    request.get(
      endpoints.backoffice(`wsbGetContactByType?contactType=${contactType}`),
    ),
  setUserContactsFavourite: ({ contactId }) =>
    request.put(
      endpoints.backoffice(`wsbUpdMainContact?contactId=${contactId}`),
    ),
};
